import { Component, EventEmitter, Inject, Input, Optional, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-confirm-dialog-common",
  templateUrl: "./confirm-dialog-common.component.html",
  styleUrl: "./confirm-dialog-common.component.scss",
})
export class ConfirmDialogCommonComponent {
  @Input() confirmDialogContent: any = {};
  @Output() confirmDialogActionCall = new EventEmitter<any>();
  isModal: boolean = true;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() private dialogRef: MatDialogRef<ConfirmDialogCommonComponent>
  ) { }

  private get hasMaterialDialogRef(): boolean {
    return typeof this.dialogRef?.close === "function";
  }

  ngOnInit(): void {
    if (this.hasMaterialDialogRef && this.data != null) {
      this.isModal = false;
      this.confirmDialogContent = this.data;
    }
  }

  alertBtnAction(btnFlag: boolean = false) {
    let data = {
      dialogkey: this.confirmDialogContent.dialogkey,
      actionValue: btnFlag,
      hasMultipleFlag: this.confirmDialogContent?.hasMultiple || false,
    };
    if (this.hasMaterialDialogRef) {
      this.confirmDialogContent.showConfirmDialog = false;
      this.dialogRef?.close({ actionValue: data.actionValue });
    } else {
      this.confirmDialogActionCall.emit(data);
    }
  }
}
